<template>
  <mu-card id="blood-glucose-targets" class="bottom">
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <mu-icon style="width: 16px;" :size="20" value="settings_cog" class="card-left-icon"></mu-icon>
        <mu-flexbox-item class="left16" v-text="title"></mu-flexbox-item>
        <mu-flexbox-item
          align="right"
        >
          <mu-icon-button
            v-if="!isOpenInput"
            v-tooltip.top="isOpenInput ? $t('message.closeText') : 'Configure range'"
            class="card-bar-icon"
            :icon="'add_circle'"
            @click.native="openInput"
          />
          <mu-icon-button
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove_circle_outline'"
            @click.native="openInput"
          />
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form v-on:submit.prevent="saveSettings" v-if="isOpenInput">
      <mu-card-text>
        <div>
          <vue-slider v-bind="sliderSettings" v-model="sliderSettings.value"></vue-slider>
        </div>
      </mu-card-text>
      <mu-card-actions align="right">
        <mu-flat-button
          :label="$t('message.discardText')"
          @click.native="close"
          class="demo-flat-button"
        />
        <button type="submit" style="display: none;"></button>
        <mu-flat-button
          type="button"
          @click.native="saveSettings"
          :disabled="isSaving"
          :label="isSaving ? $t('message.updatingText'): $t('message.updateText')"
          class="demo-flat-button"
        />
      </mu-card-actions>
    </form>
  </mu-card>
</template>
<script type="text/babel">
  import SettingsApi from '../../../api/Settings'
  import CardAnimationMixin from '../../../mixins/CardAnimationMixin'
  import vueSlider from 'vue-slider-component/src/vue2-slider.vue'
  import {TweenMax, Power2, TimelineLite} from 'gsap'
  import DatePicker from "../../DateTimePicker/DateTimePicker.vue";

  export default {
    name: 'blood-glucose-targets',
    mixins: [CardAnimationMixin],
    components: {
      DatePicker,
      vueSlider
    },
    props: {
      bloodGlucose: {},
      hba1c: {}
    },
    data() {
      return {
        title: this.$t('message.labelUpdateRange'),
        isOpenInput: false,
        isSaving: false,
        loading: true,
        value: [0, 5],
        settings: {},
        scroller: document.getElementsByClassName('main-content')[0],
        sliderSettings: {
          value: [4, 7],
          width: '100%',
          height: 8,
          dotSize: 16,
          min: 0,
          max: 500,
          disabled: false,
          show: true,
          tooltip: 'always',
          formatter: '{value}',
          bgStyle: {
            backgroundColor: '#fff',
            boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
          },
          tooltipStyle: {
            backgroundColor: '#E74C27',
            borderColor: '#E74C27'
          },
          processStyle: {
            backgroundColor: '#E74C27'
          }
        },
        readingTags: [],
        model: {
          tags: []
        }
      }
    },
    mounted() {
      let self = this;
      self.sliderSettings.max = self.bloodGlucose.measure === 'mmoll' ? 30 : 500;
      SettingsApi.getBloodSugarSettings()
        .then(function (response) {
          self.sliderSettings.value = [
            response.data.glucose_range.min,
            response.data.glucose_range.max
          ];
        })
    },
    methods: {
      saveSettings() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid) {

              self.isSaving = true;
              let min = self.sliderSettings.value[0];
              let max = self.sliderSettings.value[1];
              let body = {
                glucose_range: {
                  min: min,
                  max: max
                }
              };
              SettingsApi.updateUserSettings(body)
                .then(function (response) {
                  self.$toastr.success(self.$t('message.labelRangeUpdated'));
                  self.isSaving = false;
                  self.isOpenInput = false;
                }, function (error) {
                  self.data = error;
                  self.isSaving = false;
                  self.loading = false
                })
            }
            else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      close() {
        this.isOpenInput = false
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
      }
    }
  }
</script>




// WEBPACK FOOTER //
// BloodGlucose.vue?d7185908